import React from 'react';
import './icon.scss';

export const PlaneIcon: React.FC<JSX.IntrinsicElements['svg']> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className,
  direction,
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className || ''} ${direction || ''}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="plane-icon"
      viewBox="0 0 24 24"
    >
      <path
        fill={fill || '#7E8A96'}
        d="M9.00967 5.12793H11.0097C12.1142 5.12793 13.468 5.89715 14.0335 6.84603L16.5089 11.0003H21.0097C21.562 11.0003 22.0097 11.448 22.0097 12.0003C22.0097 12.5526 21.562 13.0003 21.0097 13.0003H16.4138L13.9383 17.1546C13.3729 18.1035 12.0191 18.8727 10.9145 18.8727H8.91454L12.4138 13.0003H5.42485L3.99036 15.4532H1.99036L4.00967 12.0003L4.00967 11.9673L2.00967 8.54745H4.00967L5.44417 11.0003H12.5089L9.00967 5.12793Z"
      />
    </svg>
  );
};

export default PlaneIcon;
